import { useEffect } from "react";

function setMeta(attr, key, content) {
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}

export default function Seo({ title, description }) {
    useEffect(() => {
        if (title) {
            document.title = title;
            setMeta("property", "og:title", title);
            setMeta("name", "twitter:title", title);
        }
        if (description) {
            setMeta("name", "description", description);
            setMeta("property", "og:description", description);
            setMeta("name", "twitter:description", description);
        }
    }, [title, description]);
    return null;
}
